module.exports = __webpack_public_path__ + "img/success.4a0840d4.png";